"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSigma = void 0;
const context_1 = require("../context");
function useSigma() {
    return context_1.useSigmaContext().sigma;
}
exports.useSigma = useSigma;
//# sourceMappingURL=useSigma.js.map